import { render, staticRenderFns } from "./my-character.vue?vue&type=template&id=5ada8b45&scoped=true&"
import script from "./my-character.vue?vue&type=script&lang=ts&"
export * from "./my-character.vue?vue&type=script&lang=ts&"
import style0 from "./my-character.vue?vue&type=style&index=0&id=5ada8b45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada8b45",
  null
  
)

export default component.exports